import request from '@/utils/request';

// 券码核销列表页
function ticketCancelCheck(data) {
  return request({
    url: '/cp/v1/activity/card/check',
    method: 'post',
    data,
  });
}

// 券码核销列表页
function ticketList(query) {
  return request({
    url: '/cp/v1/activity/card/list',
    method: 'get',
    params: query,
  });
} 

export default{
  ticketList,
  ticketCancelCheck
}